/**
 * Медиа-`kind` по MIME для presign (`image`/`video`/`audio`).
 *
 * Неизвестный MIME по умолчанию даёт `null`. Передай `unknownFallback`, если
 * вызывающий домен не может жить с `null` и должен получить гарантированный
 * kind (например, upload-флоу, где что-то всё равно нужно отправить в
 * presign) — тогда возврат сужается до `"image" | "video" | "audio"`.
 */
export function mediaKindFromMime(mime: string): "image" | "video" | "audio" | null;
export function mediaKindFromMime(
    mime: string,
    unknownFallback: "image" | "video" | "audio",
): "image" | "video" | "audio";
export function mediaKindFromMime(
    mime: string,
    unknownFallback?: "image" | "video" | "audio",
): "image" | "video" | "audio" | null {
    if (mime.startsWith("image/")) return "image";
    if (mime.startsWith("video/")) return "video";
    if (mime.startsWith("audio/")) return "audio";
    return unknownFallback ?? null;
}

const VIDEO_EXTENSIONS = [".mp4", ".webm", ".mov", ".m4v", ".ogv"];

/** True, если URL указывает на видео-файл (по расширению пути, query/hash игнорируются).
 *  Нужно там, где известен только URL без MIME/kind — например, thumbnail чата в
 *  реестре: видео-URL нельзя рисовать через `<img>` (даёт пустой кадр), для него —
 *  `VideoThumbnail` (первый кадр через `#t`). */
export function isVideoUrl(url: string): boolean {
    const path = url.split(/[?#]/, 1)[0]?.toLowerCase() ?? "";
    return VIDEO_EXTENSIONS.some((ext) => path.endsWith(ext));
}
